<template>
  <div id="SectionHeroNetZero">
    <UIContainer class="SectionHeroNetZero__container">
      <template #left>
        <!-- Main Headline -->
        <SectionTitle titleTag="h1">
          <template #title>
            <span class="SectionHeroNetZero__title-highlight">
              Build a science-backed roadmap
            </span>
            to Net Zero
          </template>
        </SectionTitle>

        <!-- Description -->
        <p class="SectionHeroNetZero__description">
          Reduce carbon emissions and track your progress, with our easy-to-use
          and powerful Carbon Emission Reduction Software for SMEs, and support
          from an expert.
        </p>

        <!-- Social Proof -->
        <div class="SectionHeroNetZero__social-proof">
          <SectionSocialProof />
        </div>

        <!-- CTA Button -->
        <div class="SectionHeroNetZero__cta">
          <UIButton size="xl" theme="primary" :to="{ name: 'Contact' }">
            Schedule a call
          </UIButton>
        </div>
      </template>

      <template #right>
        <div class="SectionHeroNetZero__image-container">
          <img
            class="SectionHeroNetZero__image"
            src="../assets/hero/bg.avif"
            alt="Net zero hero image"
            fetchpriority="high"
            loading="eager"
          />
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import SectionSocialProof from '@/views/components/sections/SectionSocialProof.vue'
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
</script>

<style lang="scss" scoped>
#SectionHeroNetZero {
  background-color: $color-ui-gray-cool-50;

  .SectionHeroNetZero__container {
    padding: 2rem 2rem 3rem;
    position: relative;

    @include md {
      padding: 2.875rem 3rem 6rem;
    }
  }

  .SectionHeroNetZero__image-container {
    position: relative;
    display: none;

    @include md {
      display: block;
    }
  }

  .SectionHeroNetZero__image {
    object-fit: cover;
    object-position: center;
    width: 100%;
  }

  .SectionHeroNetZero__title-highlight {
    background: linear-gradient(45deg, #023025 0%, #04785e 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }

  .SectionHeroNetZero__description {
    @include font-size-18px();
    color: $color-ui-gray-cool-600;
    line-height: 1.6;
    margin-bottom: 2rem;
    max-width: 32rem;

    strong {
      font-weight: 600;
      color: $color-ui-gray-cool-900;
    }
  }

  .SectionHeroNetZero__social-proof {
    margin-bottom: 2rem;
  }

  .SectionHeroNetZero__cta {
    display: flex;
    align-items: center;
    justify-content: center;

    @include md {
      justify-content: flex-start;
    }
  }
}
</style>
